import { IOption } from "../types";

export const SET_FILTERS_STATE = "SET_FILTERS_STATE";

export function setFilterState(filtersState: string | null) {
    return {
        type: SET_FILTERS_STATE,
        payload: filtersState
    };
}
export const SET_SELECTED_SORT_OPTION = "SET_SELECTED_SORT_OPTION";

export function setSelectedSortOption(option: IOption | undefined) {
    return {
        type: SET_SELECTED_SORT_OPTION,
        payload: option
    };
}

export const SET_FULL_NAME_LIST = "SET_FULL_NAME_LIST";

export function setFullNameList(nameList: string[]) {
    return {
        type: SET_FULL_NAME_LIST,
        payload: nameList
    }
}
